import * as React from "react";
import { GenericFormConsumerInterface } from "../../../Common/hooks";
import { ShippingForm } from "./shipping-form";

export interface ShippingFormConsumerInterface
  extends GenericFormConsumerInterface<ShippingForm> {}
const defaultValue = {} as unknown as ShippingFormConsumerInterface;
export const ShippingFormContext = React.createContext(defaultValue);

export interface ShippingForm_ControllerConsumerInterface {
  resetShippingForm: () => void;

  isTheShippingFormCompleteAndValid: () => boolean;
}
const defaultControllerValue =
  {} as unknown as ShippingForm_ControllerConsumerInterface;
export const ShippingFormControllerContext = React.createContext(
  defaultControllerValue
);

export const useShippingForm = () => {
  const context = React.useContext(ShippingFormContext);
  if (context === defaultValue) {
    throw new Error(
      "useShippingForm must be used within a ShippingFormProvider"
    );
  }
  return context;
};

export const useShippingForm_asController = () => {
  const context = React.useContext(ShippingFormControllerContext);
  if (context === defaultControllerValue) {
    throw new Error(
      "useShippingForm_asController must be used within a ShippingFormProvider"
    );
  }
  return context;
};
